import type { AlertColor } from '@mui/material/Alert';
import { createContext, useContext } from 'react';

export interface Toast {
	id: number;
	message: string;
	action?: ToastAction;
	severity?: AlertColor;
}

/** Toast action label and click callback  */
export interface ToastAction {
	label: string;
	onClick: () => void;
}

/** A function that triggers a new toast message */
export type AddToast = (
	message: string,
	action?: ToastAction,
	severity?: AlertColor,
	persist?: boolean
) => void;

export const SnackbarContext = createContext<AddToast>(() => null);

/**
 * Returns the `addToast` function, to trigger a new toast message.
 *
 * The function can receive two parameters:
 *
 * - `message` - `{string}` that is shown as toast.
 * - `action` - `{object}` (optional) that will show an additional action "button"
 * - `label` - `{string}` that, if provided,  is used as the label of the action button.
 * - `onClick` - `{function}` that will be called, when the action button is clicked.
 */
export const useAddToast = () => {
	return useContext(SnackbarContext);
};
